
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="加盟类型">
              <a-select
                  showSearch
                  optionFilterProp="title"
                  v-model="queryParam.kaoji_jiameng_type"
                  placeholder="加盟类型"
                  allowClear
              >
<!--                <a-radio-button :value="2">0元</a-radio-button>-->
<!--                <a-radio-button :value="3">9800元</a-radio-button>-->
<!--                <a-radio-button :value="4">12万元</a-radio-button>-->
<!--                <a-radio-button :value="5">13.5万元</a-radio-button>-->
                <a-select-option   title="0元" :value="1">老政策</a-select-option>
                <a-select-option   title="0元" :value="2">0元</a-select-option>
                <a-select-option   title="9800元" :value="3">9800元</a-select-option>
                <a-select-option   title="12万元" :value="4">12万元</a-select-option>
                <a-select-option   title="13.5万元" :value="5">13.5万元</a-select-option>
              </a-select>
            </a-form-item>
          
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报状态">
              <a-select v-model="queryParam.kaojiregist_status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
                <a-select-option value="4">预审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>
          
          <a-col :md="6" :sm="24">
             <a-form-item label="类型">
             <a-select
                     showSearch
                     optionFilterProp="title"
                     v-model="queryParam.kaojitype"
                     placeholder="类型"
                     allowClear
             >
               <a-select-option   title="考级中心" value="考级中心">考级中心</a-select-option>
               <a-select-option   title="考级点" value="考级点">考级点</a-select-option>
             </a-select>
           </a-form-item>
          </a-col>


<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="联系电话">-->
<!--              <a-input v-model="queryParam.phone" placeholder="联系电话"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :md="6" :sm="24">
            <a-form-item label="申报时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

<!--          <a-col :md="6" :sm="24">-->
<!--            <a-form-item label="申报进度">-->
<!--              <a-select v-model="queryParam.kaoji_jindu" placeholder="请选择"-->
<!--                        allowClear >-->
<!--                <a-select-option :key="-1" value="-1">无</a-select-option>-->
<!--                &lt;!&ndash;<a-select-option value="1">等待审核</a-select-option>&ndash;&gt;-->
<!--                <a-select-option :key="2" value="2">告知省级并征求意见+申报单位积极准备中</a-select-option>-->
<!--                <a-select-option :key="4" value="4">条件已具备，等待验收</a-select-option>-->
<!--                <a-select-option :key="6" value="6">验收并授牌</a-select-option>-->
<!--                <a-select-option :key="7" value="7">同意考试</a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
<!--      <a-button @click="download(1)" style="margin-left: 8px">-->
<!--        下载（地区）信息表-->
<!--        <a-icon type="download" />-->
<!--      </a-button>-->
      <a-button @click="download(2)" style="margin-left: 8px">
        下载信息表
        <a-icon type="download" />
      </a-button>

      <a-button @click="download(3)" style="margin-left: 8px">
        下载缴费信息表
        <a-icon type="download" />
      </a-button>

      <a-dropdown v-if="  selectedRowKeys.length > 0">
        <a-menu slot="overlay">
<!--          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>-->
          <a-menu-item @click="onCenterDeleteAll" key="1"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
<!--          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" />-->
          <div style="float: left">
            {{record.danwei}}
            <a-tag v-if="record.kaojitype=='考级点'" color="green">
              考级点
            </a-tag>
            <a-tag v-else color="blue">
              考级中心
            </a-tag>

            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            负责人:{{record.nickname}} <span style="color: #999">手机:{{record.phone}}</span>
            <br/>
            联系人:{{record.contactsname}} <span style="color: #999">手机:{{record.contactsphone}}</span>

            <br/>
            加盟类型:
            <a-tag v-if="record.kaoji_jiameng_type==1">老政策</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==2">0元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==3">9800元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==4">12万元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==5">13.5万元</a-tag>
            <a-tag v-else>未知</a-tag>
            <a-tag v-if="record.from == 1" color="red">主动申请</a-tag>

            <br />
            <span v-if="record.tuijian_name">推荐人:{{record.tuijian_name}}</span>
          </div>
      </span>

      <span slot="type" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            <a-tag v-if="record.kaojitype=='考级点'" color="green">
              考级点
            </a-tag>
            <a-tag v-else color="blue">
              考级中心
            </a-tag>

          </div>
      </span>
      <span slot="price" slot-scope="text,record">
          <a-tag v-if="record.kaoji_jiameng_type==1">老政策</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==2">0元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==3">9800元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==4">12万元</a-tag>
            <a-tag v-else-if="record.kaoji_jiameng_type==5">13.5万元</a-tag>
            <a-tag v-else>未知</a-tag>
      </span>
      <span slot="jinqun" slot-scope="text,record">
          {{record.is_jinqun == 1 ? '是' : '否'}}
      </span>
      <span slot="fahuo" slot-scope="text,record">
          {{record.is_fahuo == 1 ? '已发' : '未发'}}
      </span>
      <span slot="code" slot-scope="text,record">
            {{record.kaojiregist_code?record.kaojiregist_code:'(无)'}}
            <br/>
            申请时间 {{record.create_time|timeFormat}}
            <br/>
        <span v-if="record.recommend_name" >推荐加盟人：{{record.recommend_name}}</span>

      </span>
      <span slot="jindu" slot-scope="text,record">
        <a-tag v-if="record.kaoji_jindu>0">{{record.kaoji_jindu|jinduFilter}}11</a-tag>

        <a-tag v-if="record.kaojiregist_status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==3" color="purple">审核失败</a-tag>
        <a-tag v-else-if="record.kaojiregist_status==4" color="blue">预审核</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleUserEdit(record)">人员</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="所属省市"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="类型"
                        hasFeedback
                >

                  <a-select v-model="formData.kaojitype" placeholder="请选择"
                             >
                    <a-select-option value="考级中心">考级中心</a-select-option>
                    <a-select-option value="考级点">考级点</a-select-option>
                  </a-select>
                </a-form-item>
                </a-col>
              </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入单位' }]}
        ]"
                     placeholder="请输入单位"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="授权编号"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'kaojiregist_code',
          {rules: []}
        ]"
                     placeholder="请输入授权编号"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="场地面积"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'chandimianji',
          {rules: [{ required: true, message: '请输入场地面积' }]}
        ]"
                     placeholder="请输入场地面积"/>
          </a-form-item>
            </a-col>
           <a-col :md="12" :sm="24">
         <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="拟注册运动员人数"
                 hasFeedback
         >
           <a-input type="number"  v-decorator="[
         'yundongyuanrenshu',
         {rules: [{ required: true, message: '请输入拟注册运动员人数' }]}
       ]"
                    placeholder="请输入拟注册运动员人数"/>
         </a-form-item>
             </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位地址"
                  hasFeedback
          >
            <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
            />
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="详细地址"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入详细地址' }]}
        ]"
                      placeholder="请输入详细地址"/>
          </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="已签协议"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.xieyipic"
            />
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="执照"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.zhizhaopic"
            />
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

              <a-form-item
                label="场地照片"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <pic-uploader :file-list="formData.changdipic" />
              </a-form-item>
              <!-- <a-form-item -->
                  <!-- label="电子授权书下载" -->
                  <!-- :labelCol="labelCol" -->
                  <!-- :wrapperCol="wrapperCol" -->
              <!-- > -->
<!--                <pic-uploader-->
<!--                    :file-list="formData.changdipic"-->
<!--                />-->
              <!-- </a-form-item> -->
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="协议签订"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
                <r-switch :formData="formData" field="is_xieyi" :checkedValue="1" :unCheckedValue="2" checkedChildren="是"
                          unCheckedChildren="否"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>负责人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'nickname',
          {rules: [{ required: true, message: '请输入负责人姓名' }]}
        ]"
                      placeholder="请输入负责人姓名"/>
          </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入负责人手机' }]}
        ]"
                          placeholder="请输入负责人手机"/>
              </a-form-item>
         <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="负责人身份证号"
                 hasFeedback
         >
           <a-input  v-decorator="[
         'certificatenumber',
         {rules: [{ required: true, message: '请输入负责人身份证号' }]}
       ]"
                     placeholder="请输入负责人身份证号"/>
         </a-form-item>
              </a-col>
            </a-row>
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="12" :sm="24">-->
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="负责人邮箱"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input  v-decorator="[-->
<!--          'email',-->
<!--          {rules: [{ required: true, message: '请输入负责人邮箱' }]}-->
<!--        ]"-->
<!--                      placeholder="请输入负责人邮箱"/>-->
<!--          </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="12" :sm="24">-->
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="负责人手机"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input  v-decorator="[-->
<!--          'phone',-->
<!--          {rules: [{ required: true, message: '请输入负责人手机' }]}-->
<!--        ]"-->
<!--                      placeholder="请输入负责人手机"/>-->
<!--          </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->
          <a-row :gutter="48"
                 v-if="false">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人QQ"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'qq',
          {rules: [{ required: true, message: '请输入负责人QQ' }]}
        ]"
                      placeholder="请输入负责人QQ"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人微信"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'weixin',
          {rules: [{ required: true, message: '请输入负责人微信' }]}
        ]"
                      placeholder="请输入负责人微信"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-divider>联系人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsname',
          {rules: [{ required: true, message: '请输入联系人姓名' }]}
        ]"
                      placeholder="请输入联系人姓名"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人手机"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'contactsphone',
          {rules: [{ required: true, message: '请输入联系人手机' }]}
        ]"
                          placeholder="请输入联系人手机"/>
              </a-form-item>

              </a-col>
            </a-row>

         <a-row :gutter="48"> 
           <a-col :md="12" :sm="24"> 

         <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="联系人邮箱"
                 hasFeedback
         >
           <a-input  v-decorator="[
         'contactsemail',
         {rules: [{ required: true, message: '请输入联系人邮箱' }]}
       ]"
                     placeholder="请输入联系人邮箱"/>
         </a-form-item>
             </a-col>
           <a-col :md="12" :sm="24"> 

         <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="联系人身份证"
                 hasFeedback  
         >
           <a-input  v-decorator="[
         'contactscertificatenumber',
         {rules: [{ required: true, message: '请输入联系人身份证' }]}
       ]"
                     placeholder="请输入联系人身份证"/>
         </a-form-item>
           </a-col>
           </a-row>
          <a-row :gutter="48"
                 v-if="false">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人QQ"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsqq',
          {rules: [{ required: true, message: '请输入联系人QQ' }]}
        ]"
                      placeholder="请输入联系人QQ"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人微信"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsweixin',
          {rules: [{ required: true, message: '请输入联系人微信' }]}
        ]"
                      placeholder="请输入联系人微信"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-divider>审核信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="文化布置图片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.kaoji_yanshoufile"
            />
          </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item 
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
                  label="推荐人"
                  hasFeedback
              >

              <user-picker
                  style="width: 200px; margin-right: 10px;"
                  :formData="formData"
                  field="tuijian_user_id"
              /><br/>{{formData.tuijian_name}}
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
                  label="签约时间"
                  hasFeedback
              >
              <a-date-picker
                      v-model="formData.xieyi_date_moment"
                      format="YYYY-MM-DD"
                      placeholder="签约时间"/>
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="推荐奖励金额"
                  hasFeedback
              >
                <a-input  v-decorator="[
          'tuijian_reward',
          {rules: []}
        ]"
                          placeholder="推荐奖励金额"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="是否进群"
                  hasFeedback
              >
                <r-switch :formData="formData" field="is_jinqun" :checkedValue="1" :unCheckedValue="2" checkedChildren="是"
                          unCheckedChildren="否"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="备案审核"
                  hasFeedback
          >
            <a-radio-group v-model="formData.kaojiregist_status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
              <a-radio-button :value="4">预审核</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="加盟类型"
                      hasFeedback
              >
                <a-radio-group v-model="formData.kaoji_jiameng_type" buttonStyle="solid">
                  <a-radio-button :value="0">未知</a-radio-button>
                  <a-radio-button :value="1">老政策</a-radio-button>
                  <a-radio-button :value="2">0元</a-radio-button>
                  <a-radio-button :value="3">9800元</a-radio-button>
                  <a-radio-button :value="4">12万元</a-radio-button>
                  <a-radio-button :value="5">13.5万元</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="发货状态"
                  hasFeedback
              >
                <a-radio-group v-model="formData.is_fahuo" button-style="solid">
                  <a-radio-button :value="2">
                    未发货
                  </a-radio-button>
                  <a-radio-button :value="1">
                    已发货
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                  <a-radio-group v-model="formData.is_pay" button-style="solid">
                    <a-radio-button :value="2">
                      未支付
                    </a-radio-button>
                    <a-radio-button :value="1">
                      已支付
                    </a-radio-button>
                  </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="拒绝审核理由"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'kaojiregist_status_des',
          {rules: []}
        ]"
                        placeholder="请拒绝审核理由"/>
          </a-form-item>
</a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 20 }}"
                  label="进度"
                  hasFeedback
          >
            <a-radio-group v-model="formData.kaoji_jindu" buttonStyle="solid">
<!--              <a-radio-button :value="-1">无</a-radio-button>-->
<!--              <a-radio-button :value="2">告知省级并征求意见+申报单位积极准备中</a-radio-button>-->
<!--              <a-radio-button :value="4">条件已具备，等待验收</a-radio-button>-->
<!--              <a-radio-button :value="6">验收并授牌</a-radio-button>-->
              <a-radio-button :value="7">同意考试</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48" v-if="false">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 20 }}"
                  label="器材购买"
                  hasFeedback
          >
            <a-checkbox-group
                    v-model="formData.kaoji_buyxflag"
                    name="kaoji_buyxflag"
                    :options="buyGoodsOptions"
            />
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="器材购买金额"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'kaoji_buyprice',
          {rules: [ ]}
        ]"
                      placeholder="请输入器材购买金额"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="管理员备注"
                  hasFeedback
          >
            <a-textarea  v-decorator="[
          'kaoji_buynote',
          {rules: [ ]}
        ]"
                      placeholder="请输入到账情况备注"/>
          </a-form-item>
              </a-col>
            </a-row>

      <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="是否特权账号"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="is_tequan" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      v-show="formData.is_tequan==1"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      :extra="'已使用'+formData.free_cba_cost+'次'"
                      label="CBA级培训班免费次数"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'free_cba',
          {rules: [ ]}
        ]"
                             placeholder="CBA级培训班免费次数"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48"
                 v-show="formData.is_tequan==1">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="精英特训班免费次数"
                      :extra="'已使用'+formData.free_jinying_cost+'次'"
                      hasFeedback
              ><a-input  v-decorator="[
          'free_jinying',
          {rules: [ ]}
        ]"
                         placeholder="精英特训班免费次数"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="运营管理班免费次数"
                      :extra="'已使用'+formData.free_yunying_cost+'次'"
                      hasFeedback
              ><a-input  v-decorator="[
          'free_yunying',
          {rules: [ ]}
        ]"
                         placeholder="运营管理班免费次数"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-divider>缴费信息</a-divider>


          <a-row :gutter="48"
                 >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上已付" 
                      hasFeedback
              ><a-input  v-decorator="[
          'payed_online',
          {rules: [ ]}
        ]"
                         placeholder="线上已付金额"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线下已付" 
                      hasFeedback
              ><a-input  v-decorator="[
          'payed_offline',
          {rules: [ ]}
        ]"
                         placeholder="线下已付金额"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48"
                 >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="自定义费用" 
                      hasFeedback
              ><a-input  v-decorator="[
          'diy_price',
          {rules: [ ]}
        ]"
                         placeholder="自定义费用"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="退款金额" 
                      hasFeedback
              ><a-input  v-decorator="[
          'refund_price',
          {rules: [ ]}
        ]"
                         placeholder="退款金额"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48"
                 >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="支付时间" 
                      hasFeedback
              >
                <a-date-picker
                        v-model="formData.pay_time_moment"
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="支付时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="商户订单号" 
                      hasFeedback
              ><a-input  v-decorator="[
          'order_no',
          {rules: [ ]}
        ]"
                         placeholder="商户订单号"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48"
                 >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票抬头" 
                      hasFeedback
              ><a-input  v-decorator="[
          'fapiao_taitou',
          {rules: [ ]}
        ]"
                         placeholder="发票抬头"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票税号" 
                      hasFeedback
              ><a-input  v-decorator="[
          'fapiao_shuihao',
          {rules: [ ]}
        ]"
                         placeholder="发票税号"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48"
                 >
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票邮箱" 
                      hasFeedback
              ><a-input  v-decorator="[
          'fapiao_email',
          {rules: [ ]}
        ]"
                         placeholder="发票邮箱"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="发票手机" 
                      hasFeedback
              ><a-input  v-decorator="[
          'fapiao_phone',
          {rules: [ ]}
        ]"
                         placeholder="发票手机"/>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
        title="人员管理"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userVisible"
        @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
              :columns="userColumns"
              :dataSource="danweiUserList"
              :pagination="userPagination"
              rowKey="id"
              :scroll="{ y: 300 }"
              bordered
              @change="handleUserTableChange"
          >
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" />
              {{record.name}}
            </span>
            <template slot="action" slot-scope="text,record,index"> 
              <a-popconfirm
                  title="确定删除此人员吗"
                  @confirm="deleteUser(record,index)"
                  okText="确定"
                  cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <user-picker
                  style="width: 200px; margin-right: 10px;"
                  :formData="userFormData"
                  field="user_id"
              />
             <a-select
                 style="width: 200px; margin-right: 10px;"
                 v-model="userFormData.type"
                 placeholder="角色类型"
             >
                <a-select-option :value="1">负责人</a-select-option>
                <a-select-option :value="2">管理员</a-select-option>
                <a-select-option :value="3">教练员</a-select-option>
              </a-select>
              <a-button icon="plus" @click="addUser">新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>

  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import UserPicker from '@/components/UserPicker/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
 
  import moment from 'moment'
  import qs from 'qs'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getCenterList ,getCenterDetail,editCenter,deleteCenter, centerDeleteAll, getCenterDownloadUrl
  ,  deleteCenterUser, addCenterUser,getCenterUserList,
  } from '@/api/qcxj' 
  import setting from "@/config/setting";
  export default {
    name: 'ExameCenterList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
      UserPicker, 
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        userVisible: false,
        formData:{
          id:0,
          danwei:'',
          xieyi_date:'',
          xieyi_date_moment:null,
          changdipic:[],
          tuijian_user_id:'',
          xieyipic:[],
          namekeys:[],
          areas:[],
          zhizhaopic:[],
          kaoji_yanshoufile:[],
          kaoji_buyxflag:[],
          is_tequan:2,
          pay_time_moment:'',
          pay_time:'',
        },
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          // {
          //   title: '加盟类型',
          //   dataIndex: 'type',
          //   scopedSlots: { customRender: 'type' },
          // },
          // {
          //   title: '加盟费用',
          //   dataIndex: 'price',
          //   scopedSlots: { customRender: 'price' },
          // },
          {
            title: '授权编号',
            dataIndex: 'code',
            scopedSlots: { customRender: 'code' },
          },
          // {
          //   title: '推荐人',
          //   dataIndex: 'tuijian_name',
          // },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '是否进群',
            dataIndex: 'jinqun',
            width: 100,
            scopedSlots: { customRender: 'jinqun' },
          },
          {
            title: '发货状态',
            dataIndex: 'fahuo',
            width: 100,
            scopedSlots: { customRender: 'fahuo' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 160,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          // this.queryParam.namekeys = []
          // this.queryParam.danwei = ''
          // this.queryParam.kaoji_jiameng_type = ''
          // this.queryParam.kaojiregist_status = 0
          this.queryParam = Object.assign(this.queryParam,parameter);

          console.log(this.queryParam)
          return getCenterList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },

        userPagination:{
        },
        danweiUserList: [],
        //人员管理表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '用户名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' }
          },
          {
            title: '角色',
            width: '100px',
            dataIndex: 'role_type_name'
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' }
          }
        ],

        userFormData: {
          user_id: undefined,
          type: undefined,
          center_id: 0
        },
        userQuery:{
          status:0,
          page:1,
          keywords:undefined
        },
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getCenterDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            // if(res.data.namekey){
            //   res.data.namekeys = [res.data.namekey.substring(0,2)+'0000',res.data.namekey.substring(0,4)+'00',res.data.namekey];
            // }else{
            //   res.data.namekeys = [];
            // }

            res.data.pay_time_moment = moment(res.data.pay_time,'YYYY-MM-DD HH:mm:ss');;
            res.data.xieyi_date_moment = moment(res.data.xieyi_date*1000);

            res.data.namekeys = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.kaoji_buyxflag = res.data.kaoji_buyxflag.map(item =>{
              return parseInt(item);
            })
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },

      deleteHandle(record) {
        let self = this
        deleteCenter({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      onCenterDeleteAll() {
        let self = this
        centerDeleteAll({ ids: this.selectedRowKeys }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editCenter({
              id:self.formData.id, 
              pay_time:self.formData.pay_time_moment.format('YYYY-MM-DD HH:mm:ss'),
              xieyi_date:self.formData.xieyi_date_moment.format('YYYY-MM-DD'),
              namekey:self.formData.namekeys[self.formData.namekeys.length-1],
              kaojitype:self.formData.kaojitype,
              danwei:values.danwei,
              kaojiregist_code:values.kaojiregist_code,
              chandimianji:values.chandimianji,
              yundongyuanrenshu:values.yundongyuanrenshu,
              area:self.formData.areas[self.formData.areas.length-1],
              address:values.address,
              changdipic:self.formData.changdipic,
              zhizhaopic:self.formData.zhizhaopic,
              nickname:values.nickname,
              certificatenumber:values.certificatenumber,
              email:values.email,
              phone:values.phone,
              qq:values.qq,
              weixin:values.weixin,
              contactsname:values.contactsname,
              contactscertificatenumber:values.contactscertificatenumber,
              contactsemail:values.contactsemail,
              contactsphone:values.contactsphone,
              contactsqq:values.contactsqq,
              contactsweixin:values.contactsweixin,
              kaoji_yanshoufile:self.formData.kaoji_yanshoufile,
              kaojiregist_status:self.formData.kaojiregist_status,
              kaoji_jindu:self.formData.kaoji_jindu,
              tuijian_user_id:self.formData.tuijian_user_id,
              kaojiregist_status_des:values.kaojiregist_status_des,
              kaoji_buyxflag:self.formData.kaoji_buyxflag,
              kaoji_buyprice:values.kaoji_buyprice,
              kaoji_buynote:values.kaoji_buynote,
              tuijian_name:values.tuijian_name,
              tuijian_reward:values.tuijian_reward,
              kaoji_jiameng_type:self.formData.kaoji_jiameng_type,
              is_pay:self.formData.is_pay,
              is_fahuo:self.formData.is_fahuo,
              is_xieyi:self.formData.is_xieyi,
              is_jinqun:self.formData.is_jinqun,
              is_tequan:self.formData.is_tequan,
              free_jinying:values.free_jinying,
              free_yunying:values.free_yunying,
              free_cba:values.free_cba,

              payed_offline:values.payed_offline,
              payed_online:values.payed_online,
              diy_price:values.diy_price,
              refund_price:values.refund_price,
              order_no:values.order_no,
              fapiao_taitou:values.fapiao_taitou,
              fapiao_email:values.fapiao_email,
              fapiao_phone:values.fapiao_phone,
              fapiao_shuihao:values.fapiao_shuihao,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      download(type){
        // return
        let params = Object.assign(this.queryParam, { time_range: this.time_range_moment, type: type })
        // console.log('params', params);return
        if(type==3){
          window.open(setting.apiBaseURL+'/adminapi/examecenter/centerjiaofeiDownload?'+qs.stringify(this.queryParam));
          return ;
        }
        getCenterDownloadUrl(params)
            .then(res => {
              console.log(res)
              window.open(res.data)
            })
            .catch(err => {
              this.$message.error(err.data.msg)
            })
        return;
        switch (type) {
          case 1:
            // 地区信息表
            window.open(setting.apiBaseURL+'/adminapi/examecenter/centerDownload?saiqu=');
            break;
          case 2:
            // console.log(this.queryParam)
            //   return
            break;
        }
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },


      getDanweiUserList() {
        let self = this
        getCenterUserList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.danweiUserList = res.data.list
        })
      },
      addUser() {
        let self = this
        if (!self.userFormData.user_id) {
          self.$message.error('请选择人员')
          return
        }
        if (!self.userFormData.type) {
          self.$message.error('请选择类型')
          return
        }
        addCenterUser(self.userFormData)
            .then(res => {
              self.userFormData.user_id = undefined
              self.userFormData.type = undefined
              self.$message.success('新增成功')
              self.getDanweiUserList()
            })
            .catch(err => {
              self.$message.error(err.data.msg)
            })
      },
      deleteUser(record, index) {
        let self = this
        deleteCenterUser({
          user_id: record.user_id,
          center_id: record.center_id
        })
            .then(res => {
              self.$message.success('删除成功')
              self.danweiUserList.splice(index, 1)
            })
            .catch(err => {
              self.$message.error(err.data.msg)
            })
      },

      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        // if(filters.user_status){
        //   that.userQuery.status = filters.user_status[0];
        // }else{
        //   that.userQuery.status = 0;
        // }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.page = pagination.current;
        that.danweiUserList();
      },

      handleUserEdit(record){
        let self = this
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.userFormData.center_id = self.userQuery.center_id = record.id
        self.getDanweiUserList()
        self.userVisible = true
        // console.log(this.mdl)
      },

    },
    filters:{
      jinduFilter(value){
        switch (value){
          case 1:
            return `联系申报单位`;
          case 2:
            return `告知省级并征求意见+申报单位积极准备中`;
          case 3:
            return `申报单位积极准备中`;
          case 4:
            return `条件已具备，等待验收`;
          case 5:
            return `等待全国啦啦操验收`;
          case 6:
            return `验收并授牌`;
          case 7:
            return `同意考试`;
        }
      },
    },
    watch: {
    }
  }
</script>
